import { action, makeObservable, observable } from 'mobx';
import { ApplicationUuid } from '@bringg/types';
import { getSharedRootStore } from '@bringg-frontend/global-stores';

import { ReserveRow } from '../types';
import { isReserveRow } from '../helpers';

export class ReserveCapacityStore {
	data: ReserveRow[] = [];
	isLoading = false;
	isSaving = false;
	fetchFailed = false;
	saveFailed = false;

	constructor() {
		makeObservable(this, {
			data: observable.shallow,
			isLoading: observable,
			isSaving: observable,
			fetchFailed: observable,
			saveFailed: observable,
			fetchConfig: action,
			saveConfig: action,
			resetSaveFailed: action
		});
	}

	resetSaveFailed = (): void => {
		this.saveFailed = false;
	};

	fetchConfig = async (): Promise<void> => {
		this.isLoading = true;
		this.fetchFailed = false;

		try {
			const { applicationMerchantConfigurationStore } = getSharedRootStore().data;

			const config = await applicationMerchantConfigurationStore.fetchConfiguration(ApplicationUuid.Availability);
			const reserved_capacity = config?.reserved_capacity;

			if (!Array.isArray(reserved_capacity) || !reserved_capacity.every(isReserveRow)) {
				throw new Error('reserved_capacity property has unexpected shape');
			}

			this.data = reserved_capacity;
		} catch (error) {
			console.error('Failed to fetch reserve capacity config', error);
			this.fetchFailed = true;
		} finally {
			this.isLoading = false;
		}
	};

	saveConfig = async (rows: ReserveRow[]): Promise<void> => {
		this.isSaving = true;
		this.saveFailed = false;

		try {
			const { applicationMerchantConfigurationStore } = getSharedRootStore().data;

			const existingConfig =
				applicationMerchantConfigurationStore.getConfiguration(ApplicationUuid.Availability) ?? {};

			await applicationMerchantConfigurationStore.updateConfiguration(ApplicationUuid.Availability, {
				...existingConfig,
				reserved_capacity: rows
			});

			this.data = rows;
		} catch (error) {
			console.error('Failed to save reserve capacity config', error);
			this.saveFailed = true;
		} finally {
			this.isSaving = false;
		}
	};
}
